<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-table #dt [value]="loggedActions" [columns]="cols" dataKey="id"
                     [rowHover]="true" [rows]="100" [rowsPerPageOptions]="[10,25,50,100]"  [paginator]="true"
                     [scrollable]="false" [responsive]='true'
                     [filterDelay]="0" [globalFilterFields]="['schemaName','tableName','sessionUserName','action']"
                     sortMode="multiple" 
                     [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                     resetPageOnSort="true" 
                     [loading]="loading" responsiveLayout="scroll" 
                     styleClass="p-datatable-striped"
                     tableStyleClass="table dt-responsive nowrap w-100">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <div class="p-field col-6" style="padding: 0px">
                            <label for="usuario">Buscar por Usuario</label><br>
                            <p-autoComplete inputId="usuario" name="usuario" 
                                            [(ngModel)]="usuario" 
                                            [suggestions]="filteredUsuarios" [itemSize]="34"
                                            (completeMethod)="filtrarUsuarios($event)" field="nombre"
                                            placeholder="Ejm.: admin..." 
                                            [showEmptyMessage]="true" emptyMessage="{{appConfig.ux.emptyMsg}}"
                                            [minLength]="3" [dropdown]="true"
                                            [forceSelection]="true"
                                            [virtualScroll]="true"
                                            required>
                            </p-autoComplete>
                        </div>
                        <div class="p-field col-6 p-ml-2 p-mt-1" style="padding: 0px">
                            <label for="dtRange">Buscar sobre la Fecha de Registro</label><br>
                            <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-start table-header">
                                <p-calendar #dtCalendarInit inputId="dtRangeInit"
                                            [(ngModel)]="desde" 
                                            [ngModelOptions]="{standalone: true}"
                                            dateFormat="yy/mm/dd"
                                            placeholder="Desde..."
                                            [showTransitionOptions]="'.18s'" [hideTransitionOptions]="'.3s'"
                                            (onSelect)="onFilterDate($event)"
                                            (onInput)="onFilterDate($event)">
                                </p-calendar>
                                <span class="p-mr-2 required-asterisk">*</span>
                                <p-calendar #dtCalendarEnd inputId="dtRangeEnd"
                                            [(ngModel)]="hasta" 
                                            [ngModelOptions]="{standalone: true}"
                                            dateFormat="yy/mm/dd"
                                            placeholder="Hasta..."
                                            [showTransitionOptions]="'.18s'" [hideTransitionOptions]="'.3s'"
                                            (onSelect)="onFilterDate($event)"
                                            (onInput)="onFilterDate($event)">
                                </p-calendar>
                                <label class="p-text-center p-ml-2 p-mr-2 align-self-center">Al mes:</label>
                                <p-toggleButton onIcon="pi pi-check-circle" offIcon="pi pi-circle-off"
                                                [(ngModel)]="dtRangeMonth"
                                                [ngModelOptions]="{standalone: true}"
                                                (onChange)="onFilterDateRange($event)"
                                                class="align-self-center">
                                </p-toggleButton>
                            </div>
                        </div>
                    </div>
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <label class="p-ml-2 p-text-italic p-text-bold" style="color: firebrick">Los campos marcados con (*) son requeridos..</label>
                        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-end table-header">
                            <button pButton type="button" 
                                    label="{{appConfig.ux.actions.filter}}" 
                                    icon="pi pi-filter"
                                    (click)="buscarPorUsuarioFechas();"
                                    [disabled]="(!desde || !usuario || !puedeEjecutar('lectura'))">
                            </button>
                            <button pButton pRipple type="button"
                                    pTooltip="Limpiar Filtros" tooltipPosition="bottom"
                                    icon="pi pi-filter-slash" class="p-button-help p-ml-1"
                                    (click)="limpiarFiltros();">
                            </button>
                        </div>
                    </div>
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header p-mt-2"
                         *ngIf="loggedActions && loggedActions.length > 0">
                        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-start table-header">
                            <p-autoComplete inputId="reporte" name="reporte"
                                            [(ngModel)]="reporte"
                                            [suggestions]="reportesFiltrados" [itemSize]="34"
                                            (completeMethod)="filtrarReportes($event)" field="nombre"
                                            placeholder="Buscar..." 
                                            [showEmptyMessage]="true" emptyMessage="{{appConfig.ux.emptyMsg}}"
                                            [minLength]="3" [dropdown]="true"
                                            [forceSelection]="true"
                                            [virtualScroll]="true"
                                            [disabled]="!pdfDescargar"
                                            required>
                                <ng-template let-item pTemplate="item">
                                    <div>{{item.name}}</div>
                                </ng-template>
                            </p-autoComplete>
                            <button pButton type="button" 
                                    label="{{appConfig.ux.actions.generatePDF}}" 
                                    icon="pi pi-file-pdf" class="p-button-danger p-ml-1"
                                    (click)="generarReportePorFiltros();"
                                    [disabled]="!reporte || !reporte.id || !puedeEjecutar('lectura')">
                            </button>
                        </div>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                   placeholder="Buscar.."
                                   [(ngModel)]="dtFilter"/>
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [hidden]="!col.visible" [ngClass]="col.class">
                            {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns" [hidden]="!col.visible" [ngClass]="col.class">
                            <span *ngIf="col.field != 'actionTstampTx' && col.field != 'action'" >{{rowData[col.field]}}</span>
                            <span *ngIf="col.field == 'actionTstampTx'" >{{rowData[col.field]| date: 'yyyy/MM/dd HH:mm:ss'}}</span>
                            <span *ngIf="col.field == 'action'" >{{rowData[col.field] == 'I' ? 'CREAR' : 'MODIFICAR'}}</span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr><td [attr.colspan]="columns.length"><strong>{{appConfig.ux.emptyMsg}}</strong></td></tr>
                </ng-template>
                <ng-template pTemplate="summary" class="p-datatable-footer">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <button pButton pRipple type="button" icon="pi pi-refresh" class="p-button-primary p-button-text p-mr-2 p-mb-2" pTooltip="Refrescar" tooltipPosition="bottom"
                                (click)="dt.reset();"></button>
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!--Ventana de previsualización de reportes-->
<p-dialog [(visible)]="mostrarVisualidorReporte" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '100vw', '640px': '100vw'}" [style]="{width: '100vw'}"
          (onHide)="mostrarVisualidorReporte=false;">
    <ng-template pTemplate="header">
        <h4>{{reporte.name}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12" *ngIf="!reporteGenerado">
                <p-message severity="error" 
                           text="No fue posible obtener el reporte, cierre la ventana e intente nuevamente.">
                </p-message>
            </div>
            <div class="p-field col-12" *ngIf="reporteGenerado">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.download}}"
                        icon="pi pi-download" class="p-button-success"
                        (click)="descargarReporte()"
                        [disabled]="!reporteGenerado">
                </button>
                <pdf-viewer
                    [src]="reporteURL"
                    [rotation]="0"
                    [original-size]="false"
                    [show-all]="true"
                    [fit-to-page]="true"
                    [zoom]="1"
                    [zoom-scale]="'page-width'"
                    [stick-to-page]="false"
                    [render-text]="true"
                    [external-link-target]="'blank'"
                    [autoresize]="true"
                    [show-borders]="false"
                    style="min-width: 1024px;">
                </pdf-viewer>

            </div>
        </div>
    </ng-template>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd header="Confirmación" icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton type="button" 
                label="No"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton type="button" 
                label="Sí"
                icon="pi pi-check" class="p-ml-2"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog [(visible)]="procesando" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '90vw', '640px': '100vw'}" [style]="{width: '90vw'}"
          (onHide)="procesando=false;">
    <ng-template pTemplate="header">
        <h4>{{appConfig.ux.loadingMsg}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar> 
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="p-text-uppercase">{{appConfig.app.name}}</span>
    </ng-template>
</p-dialog>